import { useMemo } from 'react';
import { useSession } from '@/states/common';
import { getSubscriptionName } from '@/views/settings/billing/utils';
import { UserContainer } from '@/providers';

interface UseTeamLimitProps {
  teamAmount: number;
  userState: any;
}

export const useTeamLimit = ({ teamAmount, userState }: UseTeamLimitProps) => {
  const { data: session } = useSession();
  const { billing: billingInfo } = session;
  const isLegacyUser = userState?.business?.billing?.isLegacyUser;
  const isAppSumoCustomer = billingInfo?.isAppSumoCustomer;
  const isTenCodePurchaser = billingInfo?.isTenCodePurchaser;

  const isLimitMembers = useMemo(() => {
    const additionalUsers =
      isLegacyUser && (isAppSumoCustomer || isTenCodePurchaser)
        ? billingInfo?.additionalUsers || 0
        : 0;
    let subscriptionPlanName = '';
    if (isLegacyUser) {
      subscriptionPlanName = getSubscriptionName(
        userState?.business?.billing?.status,
        userState?.business?.billing?.subscriptionName
      ).plan.toLowerCase();
      if (isAppSumoCustomer || isTenCodePurchaser) {
        return teamAmount >= additionalUsers;
      }
    } else {
      subscriptionPlanName = userState?.business?.billing?.paddleSubscription?.planName?.toLowerCase();
    }
    return additionalUsers > 0 || !subscriptionPlanName?.includes('team');
  }, [
    isLegacyUser,
    isAppSumoCustomer,
    isTenCodePurchaser,
    billingInfo?.additionalUsers,
    userState?.business?.billing?.status,
    userState?.business?.billing?.subscriptionName,
    userState?.business?.billing?.paddleSubscription?.planName,
    teamAmount,
  ]);

  return {
    isLimitMembers,
    isAppSumoCustomer,
    isTenCodePurchaser,
  };
};
